import React from "react";

import spinner from "../../assets/images/ellipsis-3s-90px/Ellipsis-3s-90px.svg";

const LoadingSpinner = () => {
  return <img src={spinner} alt="loading" style={{ maxWidth: 100 }} />;
};

export default LoadingSpinner;
